import React from 'react';
import { CreditCard, DollarSign, Calculator, Clock, ShieldCheck, Truck } from 'lucide-react';

export const PaymentInfo: React.FC = () => {
  const paymentMethods = [
    {
      icon: CreditCard,
      title: 'Cartão de Crédito',
      description: 'Parcelamos em até 48x sem juros',
      details: ['Até 48x sem juros', 'Aceitamos todas as bandeiras', 'Aprovação imediata'],
      color: 'text-blue-600',
    },
    {
      icon: DollarSign,
      title: 'Entrada + Parcelas',
      description: 'Entrada facilitada e saldo parcelado',
      details: ['Entrada a partir de 10%', 'Saldo em até 36x', 'Sem consulta ao SPC/Serasa'],
      color: 'text-green-600',
    },
    {
      icon: Calculator,
      title: 'Consórcio',
      description: 'Planeje sua compra com segurança',
      details: ['Sem juros', 'Parcelas fixas', 'Contemplação rápida'],
      color: 'text-purple-600',
    },
    {
      icon: Clock,
      title: 'Financiamento CDC',
      description: 'Crédito direto ao consumidor',
      details: ['Taxas competitivas', 'Prazo de até 60 meses', 'Aprovação rápida'],
      color: 'text-orange-600',
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Formas de Pagamento
          </h2>
          <p className="text-lg text-gray-600">
            Escolha a melhor forma de pagamento para você
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {paymentMethods.map((method, index) => {
            const Icon = method.icon;
            return (
              <div key={index} className="card p-6">
                <div className="text-center mb-6">
                  <div className="bg-gray-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon size={32} className={method.color} />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {method.title}
                  </h3>
                  <p className="text-gray-600">
                    {method.description}
                  </p>
                </div>
                
                <ul className="space-y-2">
                  {method.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start space-x-2 text-sm text-gray-600">
                      <span className="text-green-500 mt-1">•</span>
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="bg-white rounded-xl p-8 max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Simule seu Financiamento
            </h3>
            <p className="text-gray-600">
              Calcule o valor das parcelas de acordo com o valor da moto
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-4 bg-blue-50 rounded-lg">
              <h4 className="font-semibold text-blue-900 mb-2">Entrada Mínima</h4>
              <p className="text-2xl font-bold text-blue-600">10%</p>
              <p className="text-sm text-blue-700">do valor total</p>
            </div>
            
            <div className="text-center p-4 bg-green-50 rounded-lg">
              <h4 className="font-semibold text-green-900 mb-2">Parcelas</h4>
              <p className="text-2xl font-bold text-green-600">12x</p>
              <p className="text-sm text-green-700">a 60x</p>
            </div>
            
            <div className="text-center p-4 bg-purple-50 rounded-lg">
              <h4 className="font-semibold text-purple-900 mb-2">Taxa de Juros</h4>
              <p className="text-2xl font-bold text-purple-600">1.9%</p>
              <p className="text-sm text-purple-700">ao mês</p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-600 mb-4">
              Exemplo: Moto de R$ 10.000,00 com entrada de R$ 1.000,00
            </p>
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-sm text-gray-600">
                Saldo de R$ 9.000,00 em 36x de R$ 320,00 (com juros de 1.9% a.m.)
              </p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <a
              href="https://wa.me/5513996763208"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-lg px-8 py-4"
            >
              Quero Simular Meu Financiamento
            </a>
          </div>
        </div>

        {/* Destaque de Confiança - Pague ao Receber */}
        <div className="bg-green-50 rounded-xl p-8 max-w-4xl mx-auto mb-12">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4">
              <ShieldCheck className="text-green-600 mr-3" size={32} />
              <h3 className="text-2xl font-bold text-green-900">PAGAMENTO 100% SEGURO</h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Truck className="text-green-600" size={24} />
                </div>
                <h4 className="font-semibold text-green-900 mb-2">Entrega em Casa</h4>
                <p className="text-green-700 text-sm">Receba sua moto no endereço desejado</p>
              </div>
              <div className="text-center">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
                  <ShieldCheck className="text-green-600" size={24} />
                </div>
                <h4 className="font-semibold text-green-900 mb-2">Pague ao Receber</h4>
                <p className="text-green-700 text-sm">Só pague quando tiver sua moto em mãos</p>
              </div>
              <div className="text-center">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Clock className="text-green-600" size={24} />
                </div>
                <h4 className="font-semibold text-green-900 mb-2">Garantia de 7 Dias</h4>
                <p className="text-green-700 text-sm">Teste sua moto com tranquilidade</p>
              </div>
            </div>
            <div className="mt-6 p-4 bg-white rounded-lg">
              <p className="text-green-800 font-semibold">
                💳 Você só paga após receber e conferir sua moto! 
                <br />Sem risco, sem complicação, total segurança para você!
              </p>
            </div>
          </div>
        </div>

        <div className="bg-yellow-50 rounded-xl p-8 max-w-4xl mx-auto">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-yellow-900 mb-4">
              Condições Especiais para Aposentados e Pensionistas
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-yellow-900 mb-2">Vantagens</h4>
                <ul className="text-sm text-yellow-800 space-y-1">
                  <li>• Taxas reduzidas</li>
                  <li>• Prazo estendido</li>
                  <li>• Aprovação facilitada</li>
                  <li>• Sem burocracia</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-yellow-900 mb-2">Requisitos</h4>
                <ul className="text-sm text-yellow-800 space-y-1">
                  <li>• Margem consignável disponível</li>
                  <li>• Documentos pessoais</li>
                  <li>• Comprovante de renda</li>
                  <li>• Aposentadoria ou pensão</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};